import cn from "classnames";
import styles from "./ListSavedSettings.module.scss";
import { IListSavedSettingsProps } from "./ListSavedSettings.props";
import { useListSavedSettingsControl } from "./useListSavedSettingsControl";
import { Button } from "antd";
import Title from "@components/global/new/Title/Title";
import { useIntl } from "react-intl";

export default function ListSavedSettings({
  ...props
}: IListSavedSettingsProps) {
  const { formatMessage } = useIntl();
  const control = useListSavedSettingsControl(props);

  return (
    <div className={styles.wrapper}>
      <Title className={styles.title}>
        {formatMessage({ id: "machines.more.clone_settings_title" })}
      </Title>
      <div className={styles.list}>
        {control.savedSettings.map((s) => (
          <div className={styles.setting}>
            <Button size='small' className={styles.btn} title={s.cloned_miner}>
              {s.cloned_miner}
            </Button>
            <span
              className={styles.remover}
              title='Delete'
              onClick={() => control.onDelete(s.cloned_miner)}
            >
              [&#8212;]
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
